(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.var.show.customer.show.project.accessControlReport', {
      url: '/access-control-report',
      template: `<new-front-container path="'access-control-report'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.AccessControlReport" | translate}}',
      },
    });
  }
})();
